<template>
	<Row>
		<AnemicButton
			tile
			:key="tab.title"
			class="tab-button mr-5"
			v-for="(tab, i) in tabs"
			:class="{ active: selectedTabIndex === i }"
			@click="$emit('update:selectedTabIndex', i)"
		>
			{{ tab.title }}
		</AnemicButton>
	</Row>
</template>
<script>
export default {
	name: 'InboxNotificationsMenuTabs',
	props: { tabs: { type: Array }, selectedTabIndex: { type: Number } },
};
</script>
<style scoped lang="scss">
.tab-button {
	width: 70px !important;
	padding: 0px !important;
	font-size: 14px !important;
	font-weight: 600 !important;
	color: #9e9e9e !important;
	line-height: 20px !important;
	border-radius: 1px !important;
	background: transparent !important;
	&.active {
		color: #4d4c52 !important;
		border-bottom: 2px solid #4d4c52 !important;
	}
}
</style>
